var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#7c818c",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.564 15.506c-9.59-10.957-19.543-10.957-29.129 0a.75.75 0 0 0 .001.989l-.001-.001c4.793 5.479 9.693 8.256 14.563 8.256h.001c4.869 0 9.771-2.777 14.564-8.256.116-.131.186-.304.186-.494s-.07-.363-.187-.495l.001.001zM3.004 16c8.704-9.626 17.291-9.622 25.992 0-8.703 9.621-17.291 9.621-25.992 0M16 11.25A4.75 4.75 0 1 0 20.75 16 4.756 4.756 0 0 0 16 11.25m0 8A3.25 3.25 0 1 1 19.25 16 3.254 3.254 0 0 1 16 19.25"
  })));
};
export default SvgEye;